import { FiMail } from "react-icons/fi";

const ContactEmail = ({email,icon:Icon}) => {
    return (
        <div className='email pe-3'>
            <a href="mailto:dummyuser@exmple.com">                           
                {Icon}
                {email}
            </a>
        </div>
    );
};

export default ContactEmail;